// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupsTable_groupsSearchbar__OQzw3 {
  margin-bottom: 48px;
}
.GroupsTable_topItemsContainer__toVUL {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin: 0px 0px 16px;
}
.GroupsTable_selectContainer__JtJTD {
  display: flex;
  align-items: center;
  column-gap: 40px;
}
.GroupsTable_paginationContainer__Qs7\\+s {
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #d1d9e2;
  border-right: 1px solid #d1d9e2;
  border-bottom: 1px solid #d1d9e2;
  padding: 16px 0px;
}
.GroupsTable_selectLabel__Ki4as {
  color: #4d4e4e;
}
.GroupsTable_selectLabelm__3y\\+jG,
.GroupsTable_seeMoreButtonText__0hcie,
.GroupsTable_createGroupButtonText__uFRC5 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.GroupsTable_seeMoreButtonText__0hcie {
  color: #5f6d7e;
}
.GroupsTable_selectWithLabel__Zs6Kn {
  display: flex;
  align-items: center;
  gap: 16px;
}
.GroupsTable_tableContainer__A5p4C {
  border: 1px solid #d1d9e2;
  overflow: hidden;
}
.GroupsTable_table__KkFo- {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.GroupsTable_tableHeaderRow__skoY6 {
  background-color: #f8f9fb;
  height: 44px;
}
.GroupsTable_groupNameHeaderCell__ONaUc {
  padding: 0px;
  width: 168px;
}
.GroupsTable_leaderHeaderCell__-niKa,
.GroupsTable_attendeesHeaderCell__YwDBP {
  padding: 0px;
  width: fit-content;
}
.GroupsTable_headerCellLabel__blX8n {
  color: rgba(95, 109, 126, 0.78);
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px 0px 0px 24px;
  text-align: start;
}
.GroupsTable_tableDataRow__SEVzp {
  border-top: 1px solid #d1d9e2;
  height: 64px;
}
.GroupsTable_tableNameCell__0ylLO {
  align-items: center;
  display: flex;
  padding-left: 24px;
}
.GroupsTable_userPhoto__TJaMo,
.GroupsTable_emptyProfilePhoto__TRw\\+B {
  border: 2px solid #ffffff;
  border-radius: 64px;
  cursor: pointer;
  height: 32px;
  margin-left: -8px;
  width: 32px;
}
.GroupsTable_emptyProfilePhoto__TRw\\+B {
  align-items: center;
  background-color: #e2e2e2;
  display: flex;
  justify-content: center;
}
.GroupsTable_profilePhotoIcon__BZ3zL {
  stroke: #5f6d7e;
}
.GroupsTable_tableNameText__U1psC {
  margin: 0px;
}
.GroupsTable_tableLeadersCell__xMNOe {
  min-width: 100px;
  padding: 0px 24px;
}
.GroupsTable_leadersContainer__71jtD {
  column-gap: 16px;
  display: flex;
}
.GroupsTable_leadersPhotosContainer__4cf0d,
.GroupsTable_leadersTextContainer__sdNN3 {
  display: flex;
  align-items: center;
}
.GroupsTable_tableLeadersText__\\+3wB9 {
  cursor: default;
  margin: 0px;
}
.GroupsTable_tableLeadersText__\\+3wB9,
.GroupsTable_voditeljiSpan__jZGl4,
.GroupsTable_tableNameText__U1psC {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  color: #2e3646;
  line-height: 17px;
  text-transform: capitalize;
}
.GroupsTable_voditeljiSpan__jZGl4 {
  letter-spacing: 0em;
  text-align: left;
  padding-left: 12px;
}
.GroupsTable_tableAttendeesCell__Ata5s {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-left: 24px;
}
.GroupsTable_avatarIcon__ZDyLA {
  width: 32px;
  height: 32px;
  border-radius: 100px;
}
.GroupsTable_attendeesPhotosContainer__kVeZE {
  display: flex;
}
.GroupsTable_tableButtonCell__F2fZ9 {
  display: flex;
  justify-content: flex-end;
}
.GroupsTable_seeMoreButton__BgqDZ {
  border: 1px solid #d1d9e2;
  margin: 0px 24px;
  width: 150px;
}
.GroupsTable_seeMoreButton__BgqDZ,
.GroupsTable_createGroupButton__Y526F {
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 40px;
  border-radius: 4px;
  align-items: center;
}
.GroupsTable_createGroupButton__Y526F {
  background-color: #cb9c2d;
  column-gap: 8px;
  width: 200px;
}
.GroupsTable_createGroupButtonText__uFRC5 {
  color: #ffffff;
  cursor: pointer;
}
.GroupsTable_createGroupButtonIcon__7YL50 {
  stroke: #ffffff;
}
.GroupsTable_userPhotoTooltip__vUzbt {
  display: none;
}
.GroupsTable_userPhotoContainer__Zyr3I {
  display: flex;
}

.GroupsTable_emptyProfilePhoto__TRw\\+B:hover .GroupsTable_userPhotoTooltip__vUzbt,
.GroupsTable_emptyProfilePhoto__TRw\\+B:hover .GroupsTable_userPhotoTooltip__vUzbt {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 1px 0px 4px 3px rgba(95, 109, 126, 0.11);
  display: flex;
  margin-top: 60px;
  padding: 4px;
  position: absolute;
}
.GroupsTable_tooltipText__dkwXs {
  color: #4d4e4e;
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  margin: 0px;
  text-transform: capitalize;
}
.GroupsTable_tableNameText__U1psC {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 900px) {
  .GroupsTable_topItemsContainer__toVUL,
  .GroupsTable_selectContainer__JtJTD,
  .GroupsTable_selectWithLabel__Zs6Kn {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .GroupsTable_topItemsContainer__toVUL,
  .GroupsTable_selectContainer__JtJTD {
    row-gap: 20px;
  }
  .GroupsTable_createGroupButton__Y526F,
  .GroupsTable_selectLabel__Ki4as {
    width: 500px;
  }
  .GroupsTable_groupsSearchbar__OQzw3 {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .GroupsTable_table__KkFo- {
    min-width: 850px;
  }
  .GroupsTable_tableContainer__A5p4C {
    overflow: scroll;
  }
}
@media screen and (max-width: 550px) {
  .GroupsTable_createGroupButton__Y526F,
  .GroupsTable_selectLabel__Ki4as {
    width: 400px;
  }
}
@media screen and (max-width: 450px) {
  .GroupsTable_createGroupButton__Y526F,
  .GroupsTable_selectLabel__Ki4as {
    width: 340px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/groups/components/groupsTable/GroupsTable.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;;;IAGE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,YAAY;EACd;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,YAAY;EACd;AACF;AACA;EACE;;IAEE,YAAY;EACd;AACF","sourcesContent":[".groupsSearchbar {\n  margin-bottom: 48px;\n}\n.topItemsContainer {\n  align-items: flex-end;\n  display: flex;\n  justify-content: space-between;\n  margin: 0px 0px 16px;\n}\n.selectContainer {\n  display: flex;\n  align-items: center;\n  column-gap: 40px;\n}\n.paginationContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid #d1d9e2;\n  border-right: 1px solid #d1d9e2;\n  border-bottom: 1px solid #d1d9e2;\n  padding: 16px 0px;\n}\n.selectLabel {\n  color: #4d4e4e;\n}\n.selectLabelm,\n.seeMoreButtonText,\n.createGroupButtonText {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.seeMoreButtonText {\n  color: #5f6d7e;\n}\n.selectWithLabel {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.tableContainer {\n  border: 1px solid #d1d9e2;\n  overflow: hidden;\n}\n.table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n.tableHeaderRow {\n  background-color: #f8f9fb;\n  height: 44px;\n}\n.groupNameHeaderCell {\n  padding: 0px;\n  width: 168px;\n}\n.leaderHeaderCell,\n.attendeesHeaderCell {\n  padding: 0px;\n  width: fit-content;\n}\n.headerCellLabel {\n  color: rgba(95, 109, 126, 0.78);\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px 0px 0px 24px;\n  text-align: start;\n}\n.tableDataRow {\n  border-top: 1px solid #d1d9e2;\n  height: 64px;\n}\n.tableNameCell {\n  align-items: center;\n  display: flex;\n  padding-left: 24px;\n}\n.userPhoto,\n.emptyProfilePhoto {\n  border: 2px solid #ffffff;\n  border-radius: 64px;\n  cursor: pointer;\n  height: 32px;\n  margin-left: -8px;\n  width: 32px;\n}\n.emptyProfilePhoto {\n  align-items: center;\n  background-color: #e2e2e2;\n  display: flex;\n  justify-content: center;\n}\n.profilePhotoIcon {\n  stroke: #5f6d7e;\n}\n.tableNameText {\n  margin: 0px;\n}\n.tableLeadersCell {\n  min-width: 100px;\n  padding: 0px 24px;\n}\n.leadersContainer {\n  column-gap: 16px;\n  display: flex;\n}\n.leadersPhotosContainer,\n.leadersTextContainer {\n  display: flex;\n  align-items: center;\n}\n.tableLeadersText {\n  cursor: default;\n  margin: 0px;\n}\n.tableLeadersText,\n.voditeljiSpan,\n.tableNameText {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  color: #2e3646;\n  line-height: 17px;\n  text-transform: capitalize;\n}\n.voditeljiSpan {\n  letter-spacing: 0em;\n  text-align: left;\n  padding-left: 12px;\n}\n.tableAttendeesCell {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding-left: 24px;\n}\n.avatarIcon {\n  width: 32px;\n  height: 32px;\n  border-radius: 100px;\n}\n.attendeesPhotosContainer {\n  display: flex;\n}\n.tableButtonCell {\n  display: flex;\n  justify-content: flex-end;\n}\n.seeMoreButton {\n  border: 1px solid #d1d9e2;\n  margin: 0px 24px;\n  width: 150px;\n}\n.seeMoreButton,\n.createGroupButton {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  height: 40px;\n  border-radius: 4px;\n  align-items: center;\n}\n.createGroupButton {\n  background-color: #cb9c2d;\n  column-gap: 8px;\n  width: 200px;\n}\n.createGroupButtonText {\n  color: #ffffff;\n  cursor: pointer;\n}\n.createGroupButtonIcon {\n  stroke: #ffffff;\n}\n.userPhotoTooltip {\n  display: none;\n}\n.userPhotoContainer {\n  display: flex;\n}\n\n.emptyProfilePhoto:hover .userPhotoTooltip,\n.emptyProfilePhoto:hover .userPhotoTooltip {\n  background-color: #ffffff;\n  border-radius: 4px;\n  box-shadow: 1px 0px 4px 3px rgba(95, 109, 126, 0.11);\n  display: flex;\n  margin-top: 60px;\n  padding: 4px;\n  position: absolute;\n}\n.tooltipText {\n  color: #4d4e4e;\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 15px;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.tableNameText {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (max-width: 900px) {\n  .topItemsContainer,\n  .selectContainer,\n  .selectWithLabel {\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n  }\n  .topItemsContainer,\n  .selectContainer {\n    row-gap: 20px;\n  }\n  .createGroupButton,\n  .selectLabel {\n    width: 500px;\n  }\n  .groupsSearchbar {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n  .table {\n    min-width: 850px;\n  }\n  .tableContainer {\n    overflow: scroll;\n  }\n}\n@media screen and (max-width: 550px) {\n  .createGroupButton,\n  .selectLabel {\n    width: 400px;\n  }\n}\n@media screen and (max-width: 450px) {\n  .createGroupButton,\n  .selectLabel {\n    width: 340px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groupsSearchbar": `GroupsTable_groupsSearchbar__OQzw3`,
	"topItemsContainer": `GroupsTable_topItemsContainer__toVUL`,
	"selectContainer": `GroupsTable_selectContainer__JtJTD`,
	"paginationContainer": `GroupsTable_paginationContainer__Qs7+s`,
	"selectLabel": `GroupsTable_selectLabel__Ki4as`,
	"selectLabelm": `GroupsTable_selectLabelm__3y+jG`,
	"seeMoreButtonText": `GroupsTable_seeMoreButtonText__0hcie`,
	"createGroupButtonText": `GroupsTable_createGroupButtonText__uFRC5`,
	"selectWithLabel": `GroupsTable_selectWithLabel__Zs6Kn`,
	"tableContainer": `GroupsTable_tableContainer__A5p4C`,
	"table": `GroupsTable_table__KkFo-`,
	"tableHeaderRow": `GroupsTable_tableHeaderRow__skoY6`,
	"groupNameHeaderCell": `GroupsTable_groupNameHeaderCell__ONaUc`,
	"leaderHeaderCell": `GroupsTable_leaderHeaderCell__-niKa`,
	"attendeesHeaderCell": `GroupsTable_attendeesHeaderCell__YwDBP`,
	"headerCellLabel": `GroupsTable_headerCellLabel__blX8n`,
	"tableDataRow": `GroupsTable_tableDataRow__SEVzp`,
	"tableNameCell": `GroupsTable_tableNameCell__0ylLO`,
	"userPhoto": `GroupsTable_userPhoto__TJaMo`,
	"emptyProfilePhoto": `GroupsTable_emptyProfilePhoto__TRw+B`,
	"profilePhotoIcon": `GroupsTable_profilePhotoIcon__BZ3zL`,
	"tableNameText": `GroupsTable_tableNameText__U1psC`,
	"tableLeadersCell": `GroupsTable_tableLeadersCell__xMNOe`,
	"leadersContainer": `GroupsTable_leadersContainer__71jtD`,
	"leadersPhotosContainer": `GroupsTable_leadersPhotosContainer__4cf0d`,
	"leadersTextContainer": `GroupsTable_leadersTextContainer__sdNN3`,
	"tableLeadersText": `GroupsTable_tableLeadersText__+3wB9`,
	"voditeljiSpan": `GroupsTable_voditeljiSpan__jZGl4`,
	"tableAttendeesCell": `GroupsTable_tableAttendeesCell__Ata5s`,
	"avatarIcon": `GroupsTable_avatarIcon__ZDyLA`,
	"attendeesPhotosContainer": `GroupsTable_attendeesPhotosContainer__kVeZE`,
	"tableButtonCell": `GroupsTable_tableButtonCell__F2fZ9`,
	"seeMoreButton": `GroupsTable_seeMoreButton__BgqDZ`,
	"createGroupButton": `GroupsTable_createGroupButton__Y526F`,
	"createGroupButtonIcon": `GroupsTable_createGroupButtonIcon__7YL50`,
	"userPhotoTooltip": `GroupsTable_userPhotoTooltip__vUzbt`,
	"userPhotoContainer": `GroupsTable_userPhotoContainer__Zyr3I`,
	"tooltipText": `GroupsTable_tooltipText__dkwXs`
};
export default ___CSS_LOADER_EXPORT___;
